export interface CommentError {
  message: string;
  timestamp: number;
}
